<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<router-outlet ngxUiLoaderBlurred [blur]="(reportViewLoading$ | async) ? 0 : 10"></router-outlet>
<ngx-ui-loader [style.display]="(reportViewLoading$ | async) ? 'none' : null"></ngx-ui-loader>
